import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../_services';
import { LoginService } from '../../providers/login/login.service';
import { configuration } from '../../configuration';
import {MatSnackBar} from '@angular/material';
import { RegistrationValidator } from './register.validator';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent implements OnInit  {

  private classes = ['hold-transition', 'login-page'];
  public emailToRecovery: string;
  public isSubmitting = false;


public loginform:Boolean=false
public loginotpform:Boolean=false
public getotp:any
public mobilenumber:any
public msgFeedback: string;
public projectName = configuration.projectName;
constructor(private loginService: LoginService,
private snackbar:MatSnackBar,  private authService: AuthenticationService,
private formBuilder: FormBuilder,private router:Router
  ) {

    this.passwordFormGroup = this.formBuilder.group({
      otp:['', Validators.required],
      password: ['', Validators.required],
      repeatPassword: ['', Validators.required]
    }, {
      validator: RegistrationValidator.validate.bind(this)
    });
    this.registrationFormGroup = this.formBuilder.group({
    passwordFormGroup: this.passwordFormGroup
    });
   }

    registrationFormGroup: FormGroup;
    passwordFormGroup: FormGroup;

  ngOnInit() {
    
this.loginform=true
this.loginotpform=false

    const body = document.getElementsByTagName('body')[0];
    for (const cl of this.classes) {
      body.classList.add(cl);
    }
  
  
  }


genotpclick(mobilenumber)
{
if(mobilenumber!="")
{
this.authService.forgotPasswordgetotp(mobilenumber)
.subscribe(
response => {
if(response.status_code=="200")
{
this.mobilenumber=mobilenumber
//console.log("mobilenumber",mobilenumber)
//console.log("this.mobilenumber",this.mobilenumber)
//  console.log("response",response)
//  console.log("otp",response.otp)
  
this.getotp=response.Data
this.loginotpform=true
this.loginform=false
this.snackbar.open(response.Metadata.Message,'', {
    duration: 2000,
    });
  
  
}
else 
{
this.snackbar.open(response.Metadata.Message,'', {
  duration: 2000,
  });

}
})



}
else
{
this.snackbar.open("Please Enter Mobile Number",'', {
  duration: 2000,
  });
}

}


onClickRegister(formvalue)
{
//console.log("formvalue",formvalue)
//console.log("formvalue",formvalue.passwordFormGroup.password)
//console.log("formvalue",formvalue.passwordFormGroup.repeatPassword)

this.authService.forgotPasswordsave(formvalue.passwordFormGroup.password,
  formvalue.passwordFormGroup.repeatPassword,formvalue.passwordFormGroup.otp,this.mobilenumber)
.subscribe(
response => {
if(response.status_code=="200")
{
  //console.log("response",response)
  //console.log("otp",response.otp)
  this.router.navigate(["/login"]);
  this.getotp=response.otp
  this.snackbar.open(response.Metadata.Message,'', {
    duration: 2000,
    });
  
  
}
else 
{
this.snackbar.open(response.Metadata.Message,'', {
  duration: 2000,
  });

}
})




}






  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    for (const cl of this.classes) {
      body.classList.remove(cl);
    }
  }

  public async recoveryPassword(): Promise<void> {
    this.isSubmitting = true;
    this.msgFeedback = '';
    try {
     // await this.loginService.recoveryPassword(this.emailToRecovery)
      this.msgFeedback = 'Email de recuperação enviado com sucesso.';
    } catch (e) {
      switch (e.status) {
        case 'InvalidEmail':
          this.msgFeedback = 'Email inválido ou não encontrado entre os alunos cadastrados.';
          break;
        default:
          this.msgFeedback = 'Um erro inesperado aconteceu';
          break;
      }
    }
    this.isSubmitting = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/component/forgotpassword/forgotpassword.component.ts